import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import { MetricCardVariant } from "./types";

export { MetricCardVariant };

const { carbon, green, red, blue } = colorsPalettes;

export const Container = styled(Flex)`
    width: 100%;
    height: 100%;
    position: relative;
`;

export const LeftSection = styled(Stack)`
    flex: 1;
    gap: 8px;
    align-items: flex-start;
    justify-content: flex-start;
    min-width: 0;
`;

export const RightAsideCardsWrapper = styled(Stack)`
    height: 100%;
    width: 100%;
    gap: 8px;
`;

export const MainValue = styled.div`
    ${setFontVariant("h4", carbon[500])};
`;

export const ChangeChip = styled.span`
    .change-indication__value {
        font-size: 14px;
    }

    @media screen and (max-width: 1350px) {
        .change-indication__value {
            font-size: 12px;
        }
    }
`;

const getMetricCardBg = (variant: MetricCardVariant) => {
    switch (variant) {
        case MetricCardVariant.Up:
            return green[100];
        case MetricCardVariant.Declining:
            return red[100];
        default:
            return carbon[50];
    }
};

const getMetricCardColor = (variant: MetricCardVariant) => {
    switch (variant) {
        case MetricCardVariant.Up:
            return green[500];
        case MetricCardVariant.Declining:
            return red[500];
        default:
            return carbon[300];
    }
};

export const MetricCard = styled(Stack)<{ $variant: MetricCardVariant }>`
    background: ${({ $variant }) => getMetricCardBg($variant)};
    border-radius: 4px;
    padding: 4px 16px;
    align-items: center;
    justify-content: center;
    width: 100%;
    flex: 1;
`;

export const MetricCardValue = styled(Text)<{ $variant: MetricCardVariant }>`
    color: ${({ $variant }) => getMetricCardColor($variant)};
`;

export const MetricCardLabel = styled(Text)<{ $variant: MetricCardVariant }>`
    color: ${({ $variant }) => getMetricCardColor($variant)};
    text-align: center;
`;

export const ScrapingIconWrapper = styled(Flex)`
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: ${blue[400]};
`;
